export default "__VITE_ASSET__293e6e14__"